<template>
  <div class="field">
    <label class="label">
      {{ item.name }}
      <span v-if="canSaveLocal"
            class="is-pulled-right">
        <label class="has-text-weight-normal mr-1">{{ $t('save') }}</label>
        <input v-model="saveLocal"
               type="checkbox">
      </span>
    </label>
    <div class="control">
      <input
        :class="{'is-danger': !isValid}"
        :disabled="!isEditable"
        :value="inputValue"
        class="input"
        type="text"
        maxlength="255"
        @input="updateInput"
        @focus="showCounter = true"
        @blur="showCounter = false"
      >
      <small  v-show="showCounter"
              class="help counter">
        {{ inputValue?.length ?? 0 }} / {{ max }}
      </small>
    </div>
    <p
      v-if="!isValid"
      class="help is-danger"
    >
      {{ $t('invalidField', {field: item.name}) }}
    </p>
    <p  v-if="isEditable"
        class="help">
      {{ $t('charLimitHelpText', { min: this.min, max: this.max }) }}
    </p>
  </div>
</template>

<script>
import getSaveLocalState from '@/components/library/orders/cells/getSaveLocalState'

export default {
  name: 'OrderCellTextInput',
  props: {
    item: {
      type: Object,
      required: true
    },
    data: {
      type: String,
      default: ''
    },
    canSaveLocal: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: ""
    }
  },
  data () {
    return {
      value: this.data || '',
      showCounter: false
    }
  },
  watch: {
    data () {
      this.value = this.data || ''
    },
    saveLocal () {
      this.change()
    }
  },
  computed: {
    inputValue: {
      get () {
        return this.value || this.data
      },
      set (value) {
        if (this.value !== value) {
          this.value = value
          this.change()
        }
      }
    },
    isRequired() {
      return this.item.required
    },
    min() {
      const { minCharLimit } = this.item
      if (minCharLimit !== undefined) {
        return minCharLimit
      }
      return this.isRequired ? 1 : 0
    },
    max() {
      return this.item.maxCharLimit ?? 255
    },
    isOpen() {
      return this.status.toLowerCase() === 'open'
    },
    isValid () {
      const charCount = this.inputValue?.length ?? 0
      if (!this.item.required && (charCount === 0)) {
        return true
      }
      return (charCount <= this.max) && (charCount >= this.min)
    },
    isEditable () {
      return this.item.editable && this.canEdit
    }
  },
  methods: {
    /* eslint-disable no-invalid-this */
    // TODO - fix this if you happen to be working in this file.  The value of 'this' is potentially
    // ambuguous
    updateInput(e) {
      let value = e.target.value
      if (value.length > this.max) {
        value = value.slice(0, this.max)
        e.target.value = value
      }
      this.inputValue = value
    },
    /* eslint-enable no-invalid-this */
    change () {
      this.$emit('change', {
        field: this.item,
        value: this.value,
        updateLocal: this.saveLocal && this.isValid
      })
    }
  },
  setup (props) {
    const { saveLocal } = getSaveLocalState(props)
    return { saveLocal }
  }
}
</script>

<style scoped>
.field {
  padding: .5rem 1rem;
  width: 100%;
}
</style>
